/**
 * Account Header Component
 * Header for account pages with back button and logout
 * 
 * Back arrow logic:
 * - Shows back arrow when navigated from another account page (location.state.fromPage exists)
 * - Hides back arrow when page is opened directly from businessApp (no fromPage in state)
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, LogOut } from 'lucide-react';
import { useAccountAuth } from '../../contexts/AccountAuthContext';

const AccountHeader = ({ title, showBack = true, showLogout = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAccountAuth();

  const isFromApp = sessionStorage.getItem('from_app') === 'true';
  // Show back arrow only if user navigated here from another account page
  const hasNavigationHistory = !!location.state?.fromPage;

  const handleBack = () => {
    navigate(-1);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/app/account');
  };

  return (
    <header className="sticky top-0 z-10 bg-dark border-b border-white/10">
      <div className="flex items-center justify-between px-4 py-4">
        {/* Left - Back Button */}
        <div className="w-20">
          {showBack && hasNavigationHistory && (
            <button
              onClick={handleBack}
              className="flex items-center gap-1 text-gray-400 hover:text-white transition-colors"
            >
              <ArrowLeft size={20} />
              <span className="text-sm">Back</span>
            </button>
          )}
        </div>

        {/* Center - Title */}
        <h1 className="text-lg font-semibold text-white">{title}</h1>

        {/* Right - Logout */}
        <div className="w-20 flex justify-end">
          {showLogout && !isFromApp && (
            <button
              onClick={handleLogout}
              className="flex items-center gap-1 text-gray-400 hover:text-red-400 transition-colors"
            >
              <LogOut size={18} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default AccountHeader;
